import { t } from 'i18next';
import type { MouseEvent } from 'react';

interface ToggleMoreButtonProps {
  expanded: boolean;
  onToggle: (e: MouseEvent<HTMLButtonElement>) => void | unknown;
  /** 접힌 상태에서 표시할 텍스트 (기본: "more+") */
  moreLabel?: string;
  /** 펼친 상태에서 표시할 텍스트 (기본: "접기") */
  lessLabel?: string;
  className?: string;
}

/**
 * 콘텐츠 더보기/접기 텍스트 토글 버튼.
 * 프로젝트 전반에서 일관된 스타일로 사용.
 */
export default function ToggleMoreButton({
  expanded,
  onToggle,
  moreLabel = t('More', '더보기'),
  lessLabel = t('Hide', '숨기기'),
  className = '',
}: ToggleMoreButtonProps) {
  return (
    <button
      type="button"
      className={`toggle-more-btn ${className}`}
      onClick={onToggle}
    >
      {expanded ? lessLabel : moreLabel}
    </button>
  );
}
